import {
  Box, Button, Flex, Input, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useReducer } from "react";
import { useAuth } from "../../../Hooks/useAuth";
import { api } from "../../../services/api";
import swal from "sweetalert";

const GREEN  = "#004a33";
const ORANGE = "#fc8f04";

function FormField({ label, children }) {
  return (
    <Box mb="14px">
      <Text fontSize="11px" fontWeight="700" color="gray.500" mb="5px" textTransform="uppercase" letterSpacing="0.05em">
        {label}
      </Text>
      {children}
    </Box>
  );
}

const inputProps = {
  borderRadius: "8px",
  fontSize: "14px",
  bg: "white",
  border: "1px solid rgba(0,74,51,.2)",
  _focus: { borderColor: GREEN, boxShadow: `0 0 0 1px ${GREEN}` },
};

export function EditBatch({ productId, productBatch, onUpdateBatch }) {
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [batch, setBatch] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { stock: "", discount_per_centage: "", start_date: "", expiration_date: "", unity_of_measurement: "" }
  );

  useEffect(() => { setBatch(productBatch); }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBatch({ [name]: value });
  };

  async function handleSave(e) {
    e.preventDefault();
    const formData = new FormData();
    formData.append("batch[stock]", Number(batch.stock));
    formData.append("batch[discount_per_centage]", batch.discount_per_centage);
    formData.append("batch[start_date]", batch.start_date);
    formData.append("batch[expiration_date]", batch.expiration_date);
    formData.append("batch[unity_of_measurement]", batch.unity_of_measurement);
    const response = await api.put(`/api/v1/batches/${batch.id}`, formData, {
      headers: { "access-token": user.token, client: user.client, uid: user.uid, accept: "application/json", contentType: "multipart/form-data" },
    });
    if (response.status === 200) {
      onUpdateBatch(response.data);
      swal({ title: "Atualizado!", text: "Lote atualizado com sucesso.", icon: "success" });
      onClose();
    } else {
      swal({ title: "Erro", text: "Algo deu errado.", icon: "error" });
      onClose();
    }
  }

  return (
    <>
      <Button
        size="sm" borderRadius="8px" px="14px"
        bg={GREEN} color={ORANGE} fontWeight="700" fontSize="12px"
        _hover={{ opacity: 0.85 }} onClick={onOpen}
      >
        Editar Lote
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0,0,0,.45)" backdropFilter="blur(2px)" />
        <ModalContent borderRadius="16px" overflow="hidden" mx="16px">
          <ModalHeader bg={GREEN} py="14px" px="20px" pr="44px">
            <Text fontSize="15px" fontWeight="800" color={ORANGE}>Editar Lote</Text>
            <Text fontSize="11px" color="rgba(255,255,255,.45)" fontWeight="500" mt="1px">Lote #{batch?.id}</Text>
          </ModalHeader>
          <ModalCloseButton color="rgba(255,255,255,.6)" _hover={{ color: "white", bg: "transparent" }} top="12px" right="14px" />
          <ModalBody px="20px" py="20px" bg="#fafbfc">
            <Flex gap="10px">
              <Box flex="1">
                <FormField label="Estoque">
                  <Input value={batch.stock} name="stock" type="number" onChange={handleChange} {...inputProps} />
                </FormField>
              </Box>
              <Box flex="1">
                <FormField label="Desconto (%)">
                  <Input value={batch.discount_per_centage} name="discount_per_centage" type="number" onChange={handleChange} {...inputProps} />
                </FormField>
              </Box>
            </Flex>
            <FormField label="Data de início">
              <Input value={batch.start_date ? batch.start_date.substring(0, 10) : ""} name="start_date" type="date" onChange={handleChange} {...inputProps} />
            </FormField>
            <FormField label="Data de expiração">
              <Input value={batch.expiration_date ? batch.expiration_date.substring(0, 10) : ""} name="expiration_date" type="date" onChange={handleChange} {...inputProps} />
            </FormField>
            <FormField label="Unidade de medida">
              <Select value={batch.unity_of_measurement} name="unity_of_measurement" onChange={handleChange} {...inputProps}>
                <option value="">Selecionar unidade</option>
                <option value="Caixa">Caixa</option>
                <option value="Fardo">Fardo</option>
                <option value="Pacote">Pacote</option>
                <option value="Unidade">Unidade</option>
              </Select>
            </FormField>
          </ModalBody>
          <ModalFooter bg="white" borderTop="1px solid rgba(0,74,51,.08)" px="20px" py="12px" gap="8px" justifyContent="flex-end">
            <Button size="sm" variant="ghost" colorScheme="gray" borderRadius="8px" onClick={onClose}>Cancelar</Button>
            <Button size="sm" bg={GREEN} color={ORANGE} borderRadius="8px" px="16px" fontWeight="700" fontSize="12px" _hover={{ opacity: 0.88 }} onClick={handleSave}>
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
